// Default hits per page for vehicle search results. Mirrored by
// overrideVehicleSearchParams in src/data/search/vehicles/useVehicles.ts.
export const SEARCH_HITS_PER_PAGE = 24;

const parseOffset = (raw: string | null): number => {
  if (!raw) return 0;
  const parsed = Number.parseInt(raw, 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
};

// 1-indexed page number for the given offset. Returns 1 for missing or
// non-positive offsets.
export const getSearchPageNumber = (offset: number): number => {
  if (offset <= 0) return 1;
  return Math.floor(offset / SEARCH_HITS_PER_PAGE) + 1;
};

interface SearchPaginationState {
  page: number;
  offset: number;
  isPaginated: boolean;
}

// Reads pagination state from raw URL search params. `isPaginated` is true for
// any positive offset and drives UX: the H1 and title get a "page X" suffix and
// the description below the H1 is hidden.
export const resolveSearchPaginationState = (rawParams: URLSearchParams): SearchPaginationState => {
  const offset = parseOffset(rawParams.get('offset'));
  const page = getSearchPageNumber(offset);
  return {
    page,
    offset,
    isPaginated: page > 1,
  };
};
